import datatable from '@core/component/datatable/datatable.js';

export function summaryRecipientsTable() {
    return datatable({
        columnDefs: [
            {width: '500px', targets: [0]},
            {width: '110px', targets: [1]},
        ]
    });
}

export default () => ({
    emailVisible: false,
    smsVisible: false,
    portalVisible: false,
    isCreationMode: false,
    emailPriority: '-', emailDate: '-', emailSendImmediate: false,
    smsPriority: '-', smsDate: '-', smsBody: '-', smsSendImmediate: false,
    portalPriority: '-', portalDateFrom: '-', portalDateTo: '-',
    portalSubject: '-', portalBody: '-',

    init() {
        const el = this.$el;
        this.isCreationMode = !el.dataset.commId;

        this.emailVisible  = el.dataset.emailEnabled  === 'true';
        this.smsVisible    = el.dataset.smsEnabled    === 'true';
        this.portalVisible = el.dataset.portalEnabled === 'true';

        this.emailPriority  = el.dataset.emailPriority  || '-';
        this.emailDate      = el.dataset.emailDate      || '-';
        this.smsPriority    = el.dataset.smsPriority    || '-';
        this.smsDate        = el.dataset.smsDate        || '-';
        this.smsBody        = el.dataset.smsBody        || '-';
        this.portalPriority  = el.dataset.portalPriority  || '-';
        this.portalDateFrom  = el.dataset.portalDateFrom  || '-';
        this.portalDateTo    = el.dataset.portalDateTo    || '-';
        this.portalSubject   = el.dataset.portalSubject   || '-';
        this.portalBody      = el.dataset.portalBody      || '-';

        const root = el.getRootNode();
        this._watchCheckbox(root, '#sendEmail',  v => { this.emailVisible  = v; });
        this._watchCheckbox(root, '#sendSms',    v => { this.smsVisible    = v; });
        this._watchCheckbox(root, '#sendPortal', v => { this.portalVisible = v; });

        root.addEventListener('kibe:summary-tab-click', () => this._syncFromForm(root));
    },

    _watchCheckbox(root, selector, setter) {
        const checkbox = root.querySelector(selector);
        if (!checkbox) return;
        setter(checkbox.checked);
        checkbox.addEventListener('change', () => setter(checkbox.checked));
    },

    _syncFromForm(root) {
        this._readSelect(root, '#emailPriority',   v => { this.emailPriority  = v; });
        this._readDateTime(root, '#emailDate',      v => { this.emailDate     = v; });
        this._readSelect(root, '#smsPriority',     v => { this.smsPriority   = v; });
        this._readDateTime(root, '#smsDate',        v => { this.smsDate      = v; });
        this._readCheckbox(root, '#emailSendImmediate', v => { this.emailSendImmediate = v; });
        this._readCheckbox(root, '#smsSendImmediate',   v => { this.smsSendImmediate   = v; });
        this._readValue(root, '#smsBody_smsContent', v => { this.smsBody     = v || '-'; });
        this._readSelect(root, '#portalPriority',  v => { this.portalPriority = v; });
        this._readDateTime(root, '#portalDateFrom', v => { this.portalDateFrom = v; });
        this._readDateTime(root, '#portalDateTo',   v => { this.portalDateTo   = v; });
        this._readValue(root, '#messageSubject_portalContent', v => { this.portalSubject = v || '-'; });
        const portalCard = root.querySelector('[x-ref="portalCard"]');
        if (portalCard) {
            const bodyEl = portalCard.querySelector('[x-ref="messageBody"]');
            if (bodyEl && bodyEl._tiptapEditor) {
                this.portalBody = bodyEl._tiptapEditor.getHTML() || '-';
            }
        }
    },

    _readSelect(root, selector, setter) {
        const el = root.querySelector(selector);
        if (el) setter(el.value || '-');
    },

    _readValue(root, selector, setter) {
        const el = root.querySelector(selector);
        if (el) setter(el.value);
    },

    _readCheckbox(root, selector, setter) {
        const el = root.querySelector(selector);
        if (el) setter(el.checked);
    },

    _readDateTime(root, selector, setter) {
        const el = root.querySelector(selector);
        if (!el) return;
        setter(el.value ? this._formatDateTime(el.value) : '-');
    },

    _formatDateTime(isoStr) {
        const [datePart, timePart] = isoStr.split('T');
        if (!datePart) return '-';
        const [y, m, d] = datePart.split('-');
        const time = timePart ? timePart.substring(0, 5) : '';
        return time ? `${d}.${m}.${y} ${time}` : `${d}.${m}.${y}`;
    }
});
